import(/* webpackMode: "eager", webpackExports: ["ResetTokenForm"] */ "/home/circleci/project/apps/sb-shell/app/(recaptcha)/password/request-reset/ResetTokenForm.tsx");
